import {StammdatenAdresse} from './stammdatenAdresse';
import {StammdatenJuristischePerson} from './stammdatenJuristischePerson';
import {StammdatenKommunikation} from './stammdatenKommunikation';
import {StammdatenNatuerlichePerson} from './stammdatenNatuerlichePerson';


export interface StammdatenBerater {
    /**
     * * 0: NatuerlichePerson * 1: JuristischePerson
     */
    typ?: StammdatenBerater.TypEnum;
    natuerlichePerson?: StammdatenNatuerlichePerson;
    juristischePerson?: StammdatenJuristischePerson;
    adressen?: Array<StammdatenAdresse>;
    kommunikation?: StammdatenKommunikation;
}

export namespace StammdatenBerater {
    export type TypEnum = 0 | 1;
    export const TypEnum = {
        NUMBER_0: 0 as TypEnum,
        NUMBER_1: 1 as TypEnum
    };
}


